'use es6';

import { createSelector } from 'reselect';
import { isEmpty } from 'underscore';
import { Map as ImmutableMap } from 'immutable';
import { hasSmartFieldsGrandFathered } from 'FormsUI/selectors/Scope';
import { updateMapKeysForUsingObjectTypes } from 'FormsUI/utils/PropertiesUtils';
import { getIsTicketForm, getFormType, getAllFieldsByPropertyId } from 'FormsUI/selectors/FormDefinition';
import { getSelectedFormItemReference } from 'FormsCommonComponents/selectors/FormSelection';
import { getObjectTypeIdValue } from 'FormsCommonComponents/form-definition/utils/FormFieldUtils';
import { isMandatoryProperty, getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import { getIsHiddenOptionDisabled } from 'FormsUI/utils/FormFieldsUtils';
import { PAYMENT_FIELD_IDENTIFIER } from 'FormsUI/constants/Payments';
export const getSelectedField = createSelector(getAllFieldsByPropertyId, getSelectedFormItemReference, (fields = new ImmutableMap(), reference) => {
  if (isEmpty(reference)) {
    return null;
  }
  return updateMapKeysForUsingObjectTypes(fields).get(reference).field;
});
const getSelectedFieldGroup = state => {
  const reference = getSelectedFormItemReference(state);
  const fields = getAllFieldsByPropertyId(state) || new ImmutableMap();
  if (!reference) {
    return {};
  }
  return (updateMapKeysForUsingObjectTypes(fields).get(reference) || {}).group;
};
const isSelectedFieldDependent = createSelector(getAllFieldsByPropertyId, getSelectedFormItemReference, (fields = new ImmutableMap(), reference) => {
  if (isEmpty(reference)) {
    return false;
  }
  const referenceObjectTypeId = updateMapKeysForUsingObjectTypes(fields).get(reference);
  return referenceObjectTypeId ? referenceObjectTypeId.isDependent : false;
});
const isSelectedFieldPayment = createSelector(getAllFieldsByPropertyId, getSelectedFormItemReference, (fields = new ImmutableMap(), reference) => {
  if (isEmpty(reference)) {
    return false;
  }
  const referenceObjectTypeId = updateMapKeysForUsingObjectTypes(fields).get(reference);
  return referenceObjectTypeId ? getPropertyObjectTypeId(referenceObjectTypeId.field) === PAYMENT_FIELD_IDENTIFIER : false;
});
export const canAddDependent = createSelector([isSelectedFieldDependent, isSelectedFieldPayment], (isDependent, isPayment) => {
  return !isDependent && !isPayment;
});
export const canBeProfilled = createSelector([isSelectedFieldDependent, isSelectedFieldPayment, hasSmartFieldsGrandFathered, getIsTicketForm, getSelectedFieldGroup], (isDependent, isPayment, isGrandfathered, isTicketForm, group = {}) => {
  return !isDependent && !isPayment && !isTicketForm && isGrandfathered && group.default;
});
export function canBeMadeRequired(state) {
  const field = getSelectedField(state);
  const formType = getFormType(state);
  if (isEmpty(field)) {
    return false;
  }
  return !field.hidden && (!field.required || !isMandatoryProperty(formType, getObjectTypeIdValue(field.objectTypeId, field.propertyObjectType), field.name));
}
export const canBeMadeHidden = state => {
  const field = getSelectedField(state);
  if (isEmpty(field)) {
    return false;
  }
  return !(field.required && !field.hidden || getIsHiddenOptionDisabled(field));
};